import { useState } from "react";
import { doc, updateDoc, arrayUnion, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { currencySymbol } from "../../utils/currencyUtils";

function ConfirmedCoopItem({ c, sym, darkMode, lang, onDelete }) {
  const [showOptions, setShowOptions] = useState(false);

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", background: darkMode ? "#1a1a1a" : "#f5f3f0", borderRadius: 10, marginBottom: 6, position: "relative" }}>
      <div>
        <span style={{ fontSize: 13, color: darkMode ? "#ccc" : "#444" }}>
          {c.name} <strong style={{ color: "#27ae60" }}>{sym}{parseFloat(c.amount).toFixed(0)}</strong>
        </span>
        {c.confirmedAt && (
          <div style={{ fontSize: 11, color: "#aaa" }}>
            {new Date(c.confirmedAt).toLocaleDateString(lang === "fi" ? "fi-FI" : lang === "es" ? "es-MX" : "en-US", { day: "numeric", month: "short", year: "numeric" })}
          </div>
        )}
      </div>
      <button style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#aaa", padding: "0 4px" }} onClick={() => setShowOptions(true)}>⋯</button>

      {showOptions && (
        <div style={{ position: "fixed", inset: 0, zIndex: 400, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.4)" }} onClick={() => setShowOptions(false)}>
          <div style={{ background: darkMode ? "#1e1e1e" : "#fff", borderRadius: 16, padding: "20px 16px", width: 280, boxShadow: "0 8px 40px rgba(0,0,0,0.3)" }} onClick={e => e.stopPropagation()}>
            <p style={{ fontSize: 14, fontWeight: 600, marginBottom: 16, textAlign: "center", color: darkMode ? "#e8e2d9" : "#1a1a1a" }}>
              {lang === "es" ? "¿Qué quieres hacer?" : "What do you want to do?"}
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <button className="btn btn-gris" style={{ fontSize: 13, color: "#c0392b", borderColor: "#c0392b" }}
                onClick={() => { setShowOptions(false); onDelete(true); }}>
                🗑️ {lang === "es" ? "Borrar y quitar de la barra de progreso" : "Delete and remove from progress bar"}
              </button>
              <button className="btn btn-gris" style={{ fontSize: 13 }}
                onClick={() => { setShowOptions(false); onDelete(false); }}>
                {lang === "es" ? "Borrar solo de aquí" : "Delete only from here"}
              </button>
              <button className="btn btn-gris" style={{ fontSize: 13 }}
                onClick={() => setShowOptions(false)}>
                {lang === "es" ? "Cancelar" : "Cancel"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function CoopPanelModal({
  lang, darkMode, user, userProfile, setUserProfile,
  coopPanelData, setCoopPanelData,
  confirmedCoops, setConfirmedCoops,
  setShowCoopPanel, deleteCoopEntry, showToast,
}) {
  const sym = currencySymbol(userProfile?.currency || "USD");

  return (
    <div className="modal-overlay" onClick={function(e) { if (e.target === e.currentTarget) setShowCoopPanel(false); }}>
      <div className="modal" style={{ overflowY: "auto", maxHeight: "88vh" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>
          <h3 style={{ fontFamily: "Playfair Display, serif", fontSize: 18, margin: 0 }}>
            💸 {lang === "es" ? "Cooperaciones recibidas" : lang === "fi" ? "Saadut osallistumiset" : "Received contributions"}
          </h3>
          <button style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#aaa" }} onClick={function() { setShowCoopPanel(false); }}>✕</button>
        </div>

        {coopPanelData === null ? (
          <div style={{ textAlign: "center", padding: "30px 0", color: "#aaa" }}>
            <div style={{ fontSize: 28, animation: "whislu-spin 1s linear infinite", marginBottom: 8 }}>🌙</div>
            {lang === "es" ? "Cargando…" : "Loading…"}
          </div>
        ) : coopPanelData.length === 0 ? (
          <div style={{ textAlign: "center", padding: "30px 0" }}>
            <div style={{ fontSize: 40, marginBottom: 10 }}>💸</div>
            <p style={{ color: "#aaa", fontSize: 14 }}>{lang === "es" ? "Aún no has recibido cooperaciones" : "No contributions received yet"}</p>
          </div>
        ) : coopPanelData.map(function(entry, i) {
          const date = entry.at
            ? new Date(entry.at).toLocaleDateString(lang === "fi" ? "fi-FI" : lang === "es" ? "es-MX" : "en-US", { day: "numeric", month: "short" })
            : "";
          return (
            <div key={i} style={{ background: darkMode ? "#1e1e1e" : "#faf8f5", border: "1px solid " + (darkMode ? "#2e2e2e" : "#e8e2d9"), borderRadius: 14, padding: "14px 16px", marginBottom: 10 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                {entry.giftPhoto
                  ? <img src={entry.giftPhoto} alt="" style={{ width: 40, height: 40, borderRadius: 8, objectFit: "cover", flexShrink: 0 }} />
                  : <div style={{ width: 40, height: 40, borderRadius: 8, background: "#e0dbd2", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0 }}>🎁</div>}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: darkMode ? "#e8e2d9" : "#1a1a1a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{entry.giftName}</div>
                  {entry.price && <div style={{ fontSize: 11, color: "#d4a853" }}>{lang === "es" ? "Meta:" : "Goal:"} {sym}{parseFloat(entry.price).toFixed(0)}</div>}
                </div>
              </div>
              <div style={{ background: darkMode ? "#2a2a2a" : "#fff", borderRadius: 10, padding: "10px 12px", marginBottom: 10 }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <div>
                    <span style={{ fontSize: 14, fontWeight: 600, color: darkMode ? "#e8e2d9" : "#1a1a1a" }}>{entry.name}</span>
                    <span style={{ fontSize: 12, color: "#999", marginLeft: 8 }}>{date}</span>
                  </div>
                  <span style={{ fontSize: 16, fontWeight: 700, color: "#27ae60" }}>{sym}{parseFloat(entry.amount).toFixed(0)}</span>
                </div>
              </div>
              <p style={{ fontSize: 12, color: "#aaa", marginBottom: 10, lineHeight: 1.5 }}>
                {lang === "es"
                  ? entry.name + " dice que te envió " + sym + parseFloat(entry.amount).toFixed(0) + (entry.method === "paypal" ? " por PayPal" : entry.method === "mercadopago" ? " por MercadoPago" : "") + ". Favor de confirmar si recibiste el pago."
                  : entry.name + " says they sent you " + sym + parseFloat(entry.amount).toFixed(0) + (entry.method === "paypal" ? " via PayPal" : entry.method === "mercadopago" ? " via MercadoPago" : "") + ". Please confirm if you received the payment."}
              </p>
              <div style={{ display: "flex", gap: 8 }}>
                <button className="btn btn-gris" style={{ flex: 1, fontSize: 12, color: "#2bc044", borderColor: "#3fc02b" }} onClick={async function() {
                  setCoopPanelData(function(prev) { return prev.filter(function(_, idx) { return idx !== i; }); });
                  if (user) {
                    try {
                      const coopKey = (entry.wishlistId || "") + "_" + (entry.giftId || "") + "_" + (entry.uid || entry.name || "") + "_" + (entry.at || "");
                      const currentConfirmed = userProfile?.confirmedCoopKeys || [];
                      if (!currentConfirmed.includes(coopKey)) {
                        await updateDoc(doc(db, "users", user.uid), {
                          confirmedCoopKeys: arrayUnion(coopKey),
                          confirmedCoopHistory: arrayUnion({
                            wishlistId: entry.wishlistId,
                            giftId: entry.giftId,
                            giftName: entry.giftName,
                            giftPhoto: entry.giftPhoto || null,
                            uid: entry.uid,
                            name: entry.name,
                            amount: entry.amount,
                            method: entry.method || null,
                            at: entry.at,
                            confirmedAt: Date.now(),
                          })
                        });
                        setUserProfile(function(p) { return {
                          ...p,
                          confirmedCoopKeys: [...(p?.confirmedCoopKeys || []), coopKey],
                          confirmedCoopHistory: [...(p?.confirmedCoopHistory || []), { ...entry, confirmedAt: Date.now() }]
                        }; });
                      }
                    } catch(e) { console.warn("confirmedCoop save error", e); }
                  }
                  showToast(lang === "es" ? "✅ Cooperación confirmada" : "✅ Contribution confirmed");
                }}>
                  ✅ {lang === "es" ? "Sí lo recibí" : "Yes, I received it"}
                </button>
                <button className="btn btn-gris" style={{ flex: 1, fontSize: 12, color: "#c0392b", borderColor: "#c0392b" }} onClick={function() { deleteCoopEntry(entry); }}>
                  ❌ {lang === "es" ? "No lo recibí" : "I didn't receive it"}
                </button>
              </div>
            </div>
          );
        })}

        {(userProfile?.confirmedCoopHistory || []).length > 0 && (
          <div style={{ marginTop: 16 }}>
            <p style={{ fontSize: 11, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: 8 }}>
              {lang === "es" ? "Confirmadas" : "Confirmed"}
            </p>
            {[...(userProfile?.confirmedCoopHistory || [])].reverse().map(function(c, ci) {
              const history = userProfile?.confirmedCoopHistory || [];
              const realIndex = history.length - 1 - ci;
              return (
                <ConfirmedCoopItem
                  key={ci} c={c} sym={sym}
                  darkMode={darkMode} lang={lang}
                  onDelete={async function(removeFromGoal) {
                    const newHistory = history.filter(function(_, idx) { return idx !== realIndex; });
                    await updateDoc(doc(db, "users", user.uid), { confirmedCoopHistory: newHistory });
                    setUserProfile(function(p) { return { ...p, confirmedCoopHistory: newHistory }; });
                    if (removeFromGoal) {
                      const wSnap = await getDoc(doc(db, "wishlists", c.wishlistId));
                      if (wSnap.exists()) {
                        const gifts = (wSnap.data().gifts || []).map(function(g) {
                          if (g.id !== c.giftId) return g;
                          return { ...g, cooperations: (g.cooperations || []).filter(function(co) { return !(co.uid === c.uid && co.at === c.at); }) };
                        });
                        await updateDoc(doc(db, "wishlists", c.wishlistId), { gifts });
                      }
                    }
                  }}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
